import React from 'react';

const COVERS = {
  dataset: {
    gradient: 'linear-gradient(135deg, #0f2b5b 0%, #1d4ed8 55%, #60a5fa 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="6" width="40" height="36" rx="4" stroke="white" strokeWidth="2.5"/>
        <line x1="4" y1="18" x2="44" y2="18" stroke="white" strokeWidth="2.5"/>
        <line x1="4" y1="30" x2="44" y2="30" stroke="white" strokeWidth="2.5"/>
        <line x1="18" y1="18" x2="18" y2="42" stroke="white" strokeWidth="2.5"/>
        <line x1="32" y1="18" x2="32" y2="42" stroke="white" strokeWidth="2.5"/>
        <line x1="11" y1="10" x2="20" y2="10" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
        <line x1="23" y1="10" x2="28" y2="10" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
      </svg>
    ),
  },
  llm: {
    gradient: 'linear-gradient(135deg, #054530 0%, #047857 55%, #34d399 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="8" width="34" height="22" rx="6" stroke="white" strokeWidth="2.5"/>
        <path d="M8 38l7-8h20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <line x1="11" y1="17" x2="30" y2="17" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="11" y1="23" x2="24" y2="23" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx="40" cy="14" r="6" stroke="white" strokeWidth="2.5"/>
        <line x1="40" y1="11" x2="40" y2="17" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="40" cy="18" r="0.5" fill="white" opacity="0"/>
      </svg>
    ),
  },
  image_model: {
    gradient: 'linear-gradient(135deg, #3b0764 0%, #7c3aed 55%, #c4b5fd 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="8" width="40" height="32" rx="4" stroke="white" strokeWidth="2.5"/>
        <circle cx="16" cy="19" r="4" stroke="white" strokeWidth="2.5"/>
        <path d="M4 36l11-11 8 8 7-10 14 13" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="38" cy="12" r="2" fill="white" opacity="0.7"/>
      </svg>
    ),
  },
  audio_model: {
    gradient: 'linear-gradient(135deg, #7c2d12 0%, #ea580c 55%, #fdba74 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <line x1="4" y1="24" x2="9" y2="24" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="12" y1="17" x2="12" y2="31" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="18" y1="11" x2="18" y2="37" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="24" y1="5" x2="24" y2="43" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="30" y1="11" x2="30" y2="37" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="36" y1="17" x2="36" y2="31" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="39" y1="24" x2="44" y2="24" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  cv_model: {
    gradient: 'linear-gradient(135deg, #1e1b4b 0%, #4338ca 55%, #818cf8 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <path d="M6 24c0 0 7.5-13 18-13s18 13 18 13-7.5 13-18 13S6 24 6 24z" stroke="white" strokeWidth="2.5"/>
        <circle cx="24" cy="24" r="6" stroke="white" strokeWidth="2.5"/>
        <circle cx="24" cy="24" r="2" fill="white"/>
        <rect x="6" y="6" width="10" height="10" rx="2" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <rect x="32" y="6" width="10" height="10" rx="2" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <rect x="6" y="32" width="10" height="10" rx="2" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <rect x="32" y="32" width="10" height="10" rx="2" stroke="white" strokeWidth="1.5" opacity="0.5"/>
      </svg>
    ),
  },
  embedding: {
    gradient: 'linear-gradient(135deg, #134e4a 0%, #0d9488 55%, #5eead4 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <line x1="6" y1="42" x2="42" y2="6" stroke="white" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.4"/>
        <circle cx="10" cy="38" r="3.5" fill="white"/>
        <circle cx="20" cy="30" r="3.5" fill="white" opacity="0.8"/>
        <circle cx="16" cy="20" r="3.5" fill="white" opacity="0.7"/>
        <circle cx="30" cy="24" r="3.5" fill="white"/>
        <circle cx="38" cy="12" r="3.5" fill="white" opacity="0.9"/>
        <circle cx="36" cy="32" r="3.5" fill="white" opacity="0.6"/>
        <line x1="10" y1="38" x2="20" y2="30" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="20" y1="30" x2="30" y2="24" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="30" y1="24" x2="38" y2="12" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="16" y1="20" x2="30" y2="24" stroke="white" strokeWidth="1.5" opacity="0.4"/>
      </svg>
    ),
  },
  other_model: {
    gradient: 'linear-gradient(135deg, #0f172a 0%, #1e293b 55%, #475569 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <circle cx="8" cy="16" r="4" fill="white" opacity="0.7"/>
        <circle cx="8" cy="32" r="4" fill="white" opacity="0.7"/>
        <circle cx="24" cy="8" r="4" fill="white"/>
        <circle cx="24" cy="24" r="5" fill="white"/>
        <circle cx="24" cy="40" r="4" fill="white" opacity="0.7"/>
        <circle cx="40" cy="18" r="4" fill="white" opacity="0.9"/>
        <circle cx="40" cy="34" r="4" fill="white" opacity="0.9"/>
        <line x1="12" y1="16" x2="19" y2="10" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="12" y1="16" x2="19" y2="24" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="12" y1="32" x2="19" y2="24" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="12" y1="32" x2="19" y2="40" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="29" y1="10" x2="36" y2="18" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="29" y1="24" x2="36" y2="18" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="29" y1="24" x2="36" y2="34" stroke="white" strokeWidth="1.5" opacity="0.5"/>
        <line x1="29" y1="40" x2="36" y2="34" stroke="white" strokeWidth="1.5" opacity="0.5"/>
      </svg>
    ),
  },
  notebook: {
    gradient: 'linear-gradient(135deg, #451a03 0%, #b45309 55%, #fcd34d 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <rect x="10" y="4" width="28" height="40" rx="3" stroke="white" strokeWidth="2.5"/>
        <line x1="10" y1="14" x2="38" y2="14" stroke="white" strokeWidth="2"/>
        <rect x="6" y="4" width="6" height="40" rx="2" stroke="white" strokeWidth="2" fill="none" opacity="0.5"/>
        <line x1="18" y1="22" x2="32" y2="22" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <line x1="18" y1="28" x2="32" y2="28" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <line x1="18" y1="34" x2="26" y2="34" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="15" cy="8.5" r="1.5" fill="white" opacity="0.7"/>
        <circle cx="15" cy="20" r="1.5" fill="white" opacity="0.5"/>
        <circle cx="15" cy="26" r="1.5" fill="white" opacity="0.5"/>
        <circle cx="15" cy="32" r="1.5" fill="white" opacity="0.5"/>
      </svg>
    ),
  },
  pipeline: {
    gradient: 'linear-gradient(135deg, #500724 0%, #be123c 55%, #fb7185 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <rect x="2" y="18" width="12" height="12" rx="3" fill="white" opacity="0.9"/>
        <rect x="18" y="8" width="12" height="12" rx="3" fill="white" opacity="0.9"/>
        <rect x="18" y="28" width="12" height="12" rx="3" fill="white" opacity="0.9"/>
        <rect x="34" y="18" width="12" height="12" rx="3" fill="white" opacity="0.9"/>
        <line x1="14" y1="22" x2="18" y2="14" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="14" y1="26" x2="18" y2="34" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="30" y1="14" x2="34" y2="22" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="30" y1="34" x2="34" y2="26" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  _default: {
    gradient: 'linear-gradient(135deg, #1e293b 0%, #334155 55%, #64748b 100%)',
    icon: (
      <svg width="56" height="56" viewBox="0 0 48 48" fill="none">
        <rect x="8" y="8" width="32" height="32" rx="6" stroke="white" strokeWidth="2.5"/>
        <line x1="16" y1="20" x2="32" y2="20" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
        <line x1="16" y1="28" x2="26" y2="28" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ),
  },
};

// Dot pattern — subtle texture
function DotPattern({ id }) {
  return (
    <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
      <defs>
        <pattern id={id} x="0" y="0" width="18" height="18" patternUnits="userSpaceOnUse">
          <circle cx="9" cy="9" r="1" fill="white" opacity="0.15" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  );
}

export default function AssetCover({ assetType, previewImage, height = 140, style = {} }) {
  if (previewImage) {
    return (
      <img
        src={previewImage}
        alt=""
        style={{ width: '100%', height, objectFit: 'cover', display: 'block', ...style }}
        onError={e => { e.target.style.display = 'none'; e.target.nextSibling && (e.target.nextSibling.style.display = 'flex'); }}
      />
    );
  }

  const cover = COVERS[assetType] || COVERS._default;
  const patternId = `dots-${assetType || 'default'}`;

  return (
    <div style={{
      width: '100%', height,
      background: cover.gradient,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'relative', overflow: 'hidden', flexShrink: 0,
      ...style,
    }}>
      <DotPattern id={patternId} />
      <div style={{ position: 'relative', filter: 'drop-shadow(0 2px 12px rgba(0,0,0,0.25))' }}>
        {cover.icon}
      </div>
    </div>
  );
}
